import Settings from "./Settings";

const PATH_PREFIX = "/content_study_record_attachments/";
const VIEWER_PARAM_KEY = "as";
const VIEWER_PARAM_VALUE = "operator";

// boron の生徒提出画像（コンテンツ学習記録の添付画像）の URL かどうか
const isContentStudyRecordAttachmentUrl = (url: URL): boolean => {
  try {
    const boronUrl = new URL(Settings.BORON_URL);
    return (
      url.origin === boronUrl.origin && url.pathname.startsWith(PATH_PREFIX)
    );
  } catch {
    return false;
  }
};

// boron の生徒提出画像の URL なら「先生として閲覧する」識別子（as=operator）を付けて返す。
// boron はセッションなしの訪問者をこの識別子で FS ログインへ送る（なければ生徒ログインへ送る）。
// 振り分けのヒントであり、認可には使われない。
export const withOperatorViewer = (url: string): string => {
  let parsed: URL;
  try {
    parsed = new URL(url);
  } catch {
    return url;
  }
  if (!isContentStudyRecordAttachmentUrl(parsed)) {
    return url;
  }
  parsed.searchParams.set(VIEWER_PARAM_KEY, VIEWER_PARAM_VALUE);
  return parsed.toString();
};
